import { useTranslation } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  type SupportedLanguage,
  isSupportedLanguage,
} from './index.ts';

export function useLanguage() {
  const { i18n } = useTranslation();
  const current: SupportedLanguage = isSupportedLanguage(i18n.language)
    ? i18n.language
    : DEFAULT_LANGUAGE;

  return {
    language: current,
    isRTL: current === 'ar',
    setLanguage: (next: SupportedLanguage) => i18n.changeLanguage(next),
    toggle: () => i18n.changeLanguage(current === 'ar' ? 'en' : 'ar'),
  };
}
